import React from 'react';
import { footerData } from '@/data/mock';
import { Mail } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="relative bg-slate-950 border-t border-slate-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_hiring-sim-platform/artifacts/cx8412dn_logo2.jpg" 
              alt="Koigon Logo" 
              className="h-10 w-10 rounded-lg object-cover"
            />
            <span className="text-white font-semibold text-lg">{footerData.brand}</span>
          </div>
          
          {/* Links */}
          <div className="flex items-center gap-6">
            {footerData.links.map((link, index) => (
              <a
                key={index}
                href={link.href}
                className="text-slate-400 hover:text-white text-sm transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>
          
          {/* Contact Email */}
          <a 
            href="mailto:info@koigonlabs.ai" 
            className="flex items-center gap-2 text-slate-400 hover:text-cyan-400 text-sm transition-colors"
          >
            <Mail size={16} />
            info@koigonlabs.ai
          </a>
        </div>
        
        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-slate-800/50 text-center">
          <p className="text-slate-500 text-sm">
            {footerData.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};
